import React from "react";
import { Navigate, useLocation, useNavigate, useParams } from "react-router-dom";
import OverviewSection from "./OverviewSection";
import MessagesSection from "./MessagesSection";
import LibrarySection from "./LibrarySection";
import DeliverySection from "./DeliverySection";
import SetupSection from "./SetupSection";
import "../../Assets/css/notifications.css";
import "../../Assets/css/notification-centre.css";

// Notification Centre (redesign R6): five sections instead of the nine tabs.
//   Overview  what needs attention now, and the last 7 days (replaces Health)
//   Messages  every event in one table; a channel opens in the side panel, then the editor
//   Library   templates (cards) and Media
//   Delivery  the delivery log and "Why not received?" as one search by person
//   Setup     WhatsApp, Email, Languages, SMS / DLT
// "Send to staff" moved next to Campaigns (/send-to-staff).
// URLs: /notification-centre/<section>[/<sub>]. One section can send you to another with openTab(key,
// payload); the payload travels in the router state ("carry").
export const SECTIONS = [
    { key: "overview", name: "Overview", Component: OverviewSection },
    { key: "messages", name: "Messages", Component: MessagesSection },
    { key: "library", name: "Library", Component: LibrarySection },
    { key: "delivery", name: "Delivery", Component: DeliverySection },
    { key: "setup", name: "Setup", Component: SetupSection },
];

// The old tab names (bookmarks, ?tab=..., and openTab calls from shared parts) and where they live now.
const OLD = {
    templates: ["messages"], events: ["messages"], wording: ["messages"],
    library: ["library", "templates"], media: ["library", "media"],
    languages: ["setup", "languages"], whatsapp: ["setup", "whatsapp"], email: ["setup", "email"], sms: ["setup", "sms"],
    log: ["delivery"], why: ["delivery"], health: ["overview"],
};
export const pathFor = (key, sub) => {
    if (key === "send") return "/send-to-staff";
    const [section, oldSub] = SECTIONS.some((s) => s.key === key) ? [key, sub] : OLD[key] || ["overview"];
    const tail = sub || oldSub;
    return `/notification-centre/${section}${tail ? `/${tail}` : ""}`;
};

const NotificationCentre = () => {
    const { section, sub } = useParams();
    const location = useLocation();
    const navigate = useNavigate();

    // /notification-centre and the old ?tab= links
    const oldTab = new URLSearchParams(location.search).get("tab");
    if (!section) return <Navigate to={oldTab ? pathFor(oldTab) : "/notification-centre/overview"} replace />;
    const active = SECTIONS.find((s) => s.key === section);
    if (!active) return <Navigate to={pathFor(section, sub)} replace />;

    const carry = location.state?.carry || null;
    // openTab(key, payload): "library" + { libraryId }, "messages" + { eventKey, audience, channel },
    // "delivery" + { filters } or { recipientType, q }, "setup" + { sub }, and the old tab names.
    const openTab = (key, payload = null) => {
        const subKey = payload?.sub || (key === "library" ? "templates" : undefined);
        navigate(pathFor(key, subKey), { state: { carry: payload } });
    };
    const Section = active.Component;

    return (
        <div className="settings-page nc-shell">
            <div className="nc-shell-head">
                <h4 className="fw-semibold mb-1">Notification Centre</h4>
                <p className="text-muted mb-0">Every message the platform sends: what it says, where it goes, and whether it arrived.</p>
            </div>
            <nav className="nc-shell-tabs" aria-label="Notification Centre">
                {SECTIONS.map((s) => (
                    <button key={s.key} type="button" className={`nc-shell-tab ${s.key === section ? "is-active" : ""}`} aria-current={s.key === section ? "page" : undefined} onClick={() => navigate(pathFor(s.key))}>{s.name}</button>
                ))}
            </nav>
            <Section key={`${section}|${location.key}`} sub={sub} carry={carry} openTab={openTab} goSub={(next) => navigate(pathFor(section, next))} />
        </div>
    );
};

export default NotificationCentre;
